import { find } from "lodash";
export const InviteNewController = ($scope,
                                           $mdDialog,
                                           $auth,
                                           callback,
                                           companiesArray,
                                           selectedCompany
) => {
    "ngInject";

    $scope.callback = callback;
    $scope.companies = companiesArray;
    $scope.selectedCompany = selectedCompany;
    $scope.groups = [
        {title: "Admin", url: "/api/groups/1/"},
        {title: "Manager", url: "/api/groups/2/"},
        {title: "Client", url: "/api/groups/3/"},
        {title: "Sub-User", url: "/api/groups/4/"}
    ];
    $scope.user = $auth.getUser();

    if ($scope.user.groups_names.indexOf("Admin") !== -1) {
        $scope.groups = $scope.groups.slice(0,4);
    } else if ($scope.user.groups_names.indexOf("Manager") !== -1) {
        $scope.groups = $scope.groups.slice(2,4);
    } else if ($scope.user.groups_names.indexOf("Client") !== -1) {
        $scope.groups = $scope.groups.slice(3,4);
    } else if ($scope.user.groups_names.indexOf("Sub-User") !== -1) {
        $scope.groups = $scope.groups.slice(4,4);
    }

    $scope.inviteObj = {
        email: "",
        company: "",
        group: "",
        clients: []
    };

    if ($scope.selectedCompany) {
        let c = find($scope.companies, {name: $scope.selectedCompany});
        $scope.inviteObj.company = c.url;
        $scope.inviteObj.group = "/api/groups/3/";
    }

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.invite = () => {
        callback($scope.inviteObj);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.inviteForm.$valid) {
                $scope.create();
            }
        }
    };
};


// WEBPACK FOOTER //
// ./sources/components/users/invite-new/invite-new.js